import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import Hover from '../components/Hover'

const styles = {
  container: {
    position: 'absolute',
    top: '10px',
    right: '100px'
  }
}

class HoverContainer extends PureComponent {
  render () {
    const { classes, data } = this.props

    if (!data) {
      return null
    }

    return (
      <div className={classes.container} >
        <Hover data={data} />
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    data: state.data['LandCover2010']
  }
}

export default connect(mapStateToProps, null)(withStyles(styles)(HoverContainer))



// WEBPACK FOOTER //
// ./src/containers/HoverContainer.js